export * from './mem-store';

import Vue, { VNode, VNodeData } from 'vue';
import _assignWith from 'lodash/assignWith';
import _isUndefined from 'lodash/isUndefined';
import Color from 'color';
import { memStore } from './mem-store';
import * as colorConst from './color-const';
import { statusInfoMap } from './status-info-map';
import { sizeMap } from './size-map';
import { LooseObject } from '../common-types';
import { ApiError, ApiErrorCode } from '../api-service';

export const utilService = {
  numberWithCommas(x: number): string {
    const parts = x.toString()
      .split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  getVueScopedSlot(scopedSlots: Vue['$scopedSlots'], slotName: string = 'default', props: any = {}): VNode[] {
    if (!scopedSlots) { return []; }
    const slot = scopedSlots[slotName];
    if (!slot) { return []; }
    const children = slot(props);
    return children || [];
  },
  extractFunctionalCompRootNodeData(contextData: VNodeData, isRootComponent: boolean = false): VNodeData {
    const data: VNodeData = {
      key: contextData.key,
      ref: contextData.ref,
      refInFor: contextData.refInFor,
      staticClass: contextData.staticClass,
      class: contextData.class,
      staticStyle: contextData.staticStyle,
      style: contextData.style,
      attrs: contextData.attrs,
      directives: contextData.directives,
    };
    if (isRootComponent) {
      data.nativeOn = contextData.nativeOn;
    } else {
      data.on = contextData.nativeOn;
    }
    return data;
  },
  assignWithoutUndefined<T, S1, S2, S3>(target: T, source1?: S1, source2?: S2, source3?: S3): T & S1 & S2 & S3 {
    const res = _assignWith(target, source1!, source2!, source3!, (objValue, sourceValue) => {
      return _isUndefined(sourceValue) ? objValue : sourceValue;
    });
    Object.keys(res)
      .forEach((key) => {
        if ((res as LooseObject)[key] === undefined) {
          delete (res as LooseObject)[key];
        }
      });
    return res;
  },
  getContrastTextColor(bgColor: string, pure: boolean = false) {
    const color = Color(bgColor);
    return color.isDark() ? (pure ? '#fff' : colorConst.dark_text) : (pure ? '#000' : colorConst.light_text);
  },
  networkErrorHandler(reasonError: any) {// it is intended to use `any` here
    let showNetworkError: boolean = false;

    if (
      (reasonError instanceof ApiError && reasonError.code === ApiErrorCode.PROT_RESP_NETWORK) ||
      (reasonError instanceof Error && reasonError.name === 'ChunkLoadError')
    ) {
      showNetworkError = true;
    }

    if (showNetworkError) {
      const doReload = window.confirm(
        [
          'Server could not be reached due to a Network Error.',
          'It is recommended to fully reload the page to try again.',
          '\nDo you want to reload the page now?',
        ].join('\n'),
      );

      if (doReload) {
        window.location.reload(true);
      }
    }
  },
  memStore,
  colorConst,
  statusInfoMap,
  sizeMap,
  localeStringCompareCollator: new Intl.Collator(undefined, { sensitivity: 'accent', usage: 'sort' }),
};
